import { tz } from '@date-fns/tz'
import { type ClassValue, clsx } from 'clsx'
import { format } from 'date-fns/format'
import { formatRelative } from 'date-fns/formatRelative'
import { es } from 'date-fns/locale/es'
import { twMerge } from 'tailwind-merge'

const argentinaTZ = tz('America/Argentina/Buenos_Aires')

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatAmount(amount: number) {
  return `$${new Intl.NumberFormat('es-AR').format(amount)}`
}

export function formatDateFull(date: Date) {
  return format(date, 'dd/MM/yyyy HH:mm:ss', { in: argentinaTZ })
}

export function formatDateRelative(date: Date, includeTime = false) {
  let formatedDate = formatRelative(date, new Date(), {
    locale: es,
    in: argentinaTZ,
  })

  if (!includeTime) {
    formatedDate = formatedDate.split('a las')[0]
  }

  return formatedDate.trim()
}
